import React from "react"
import { StaticImage } from "gatsby-plugin-image"

export default function MainCakeImage() {
  return (
    <StaticImage
      src="../images/cakes/IMG_6771-5.jpg"
      alt="Pasteleria Wedding Floral"
      placeholder="blurred"  
      className="max-w-md"
    />
  )
}